'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRotateLeft = function MdRotateLeft(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 6.8c6.6 0.8 11.8 6.4 11.8 13.2s-5.2 12.4-11.8 13.2v-3.4c4.8-0.7 8.4-4.9 8.4-9.8s-3.6-9.1-8.4-9.8v6.4l-7.5-7.4 7.5-7.6v5.2z m-9.8 23.7l2.4-2.4c1.3 1 2.7 1.5 4.2 1.7v3.4c-2.4-0.3-4.6-1.2-6.6-2.7z m-1.6-8.9c0.2 1.5 0.7 2.9 1.6 4.2l-2.3 2.3c-1.5-1.9-2.4-4.1-2.7-6.5h3.4z m1.7-7.4c-0.9 1.3-1.5 2.7-1.7 4.2h-3.4c0.3-2.4 1.2-4.6 2.7-6.5z' })
        )
    );
};

exports.default = MdRotateLeft;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/rotate-left.js
// module id = 3276
// module chunks = 0